
const recipes = [
    {
        id: 1,
        name: "creme brulee",
        makes: "6 ramekins",
        ingredients: ["2 cups heavy whipping cream", "6 large egg yolks", "1/2 cup white sugar + extra to top", 
            "1 tsp vanilla extract", "pinch of salt"],
        notes: ["add heavy whipping cream to pot on medium-low heat", "add vanilla extract", 
            "remove from heat when it starts to simmer. make sure to continue stirring to prevent curdling", 
            "combine egg yolks, sugar, and salt in separate bowl, whisk until combined", 
            "once cream has cooled a bit (3-5 minutes), slowly add cream into egg yolk mixture in intervals. constantly stir to prevent egg from cooking",
            "once combined, pour mixture into ramekins so they're 75% full", 
            "place ramekins on a baking pan and fill the bottom with water",
            "bake at 300 degrees for 30-35 minutes. use a toothpick to check if custard has set; if toothpick comes out liquidy, add time",
            "take out ramekins and let them cool in the fridge",
            "before serving, cover the top with sugar and broil for 5-10 minutes (watch carefully as it will burn quickly)",
            "enjoy!"]
    },

    {
        id: 2,
        name: "banana bread",
        makes: "1 small loaf",
        ingredients: ["1/4 cup butter", "1/2 cup sugar + extra to top", "1 egg", "2 ripe bananas",
            "3/4 cup all purpose flour", "1/2 tsp baking soda", "1/4 teaspoon vanilla extract",
            "3/4 tsp cinnamon + extra to top", "crushed walnuts and pecans, if desired"],
        notes: ["peel and mash bananas finely (I use a fork)", 
            "soften butter in microwave and combine with other wet ingredients",
            "mix in dry ingredients", "if desired, pretty finely chop up walnuts and/or pecans and add",
            "grease pan with oil or butter and pour", "top with cinnamon and sugar", 
            "bake at 350F for 20 minutes, checking for toothpick to remove cleanly", 
            "enjoy!"]
    }
    
    
    // fruit tart, cinammon buns, chocolate cupcakes
]

export default recipes;
